import { Radio } from 'antd';
import { paymentTypePersianNames } from 'global/Constants/globalConstants';
import { FC, useEffect } from 'react';

interface IPaymentTypeReceiverNoCOD {
  isSelected: boolean;
  onChange: () => void;
  invalid: boolean;
  setError: (_error: string) => void;
  error: string;
}

const PaymentTypeReceiverNoCOD: FC<IPaymentTypeReceiverNoCOD> = ({ isSelected, onChange, invalid, setError, error }) => {
  useEffect(() => {
    if (error && isSelected) setError('');
  }, [error, isSelected]);

  if (invalid) return null;

  return (
    <div className='flex items-center w-full px-4 py-2 text-sm border rounded-md cursor-pointer md:max-w-lg border-t-primary-color hover:border-t-primary-color' onClick={onChange}>
      <div className='flex flex-col justify-between w-full md:items-center md:flex-row'>
        <div className='flex items-center gap-2'>
          <Radio checked={isSelected} />
          <div>
            <span className='block text-base font-bold'>{paymentTypePersianNames[20].title}</span>
            <span className='text-t-secondary-text-color'>{paymentTypePersianNames[20].description}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentTypeReceiverNoCOD;
